import { publicKeyFromAddress } from "@ergolabs/ergo-sdk";
import { TokenLockTemplateHash } from "../contracts/lockingTemplates";
export function mkLocksHistory(network, parser) {
    return new DefaultLocksHistory(network, parser);
}
class DefaultLocksHistory {
    constructor(network, parser) {
        this.network = network;
        this.parser = parser;
    }
    async getAllByAddresses(addresses) {
        const ops = [];
        for (const pk of addresses.map(publicKeyFromAddress)) {
            if (pk) {
                const query = {
                    ergoTreeTemplateHash: TokenLockTemplateHash,
                    registers: {
                        R5: pk
                    }
                };
                const limit = 100;
                let offset = 0;
                // eslint-disable-next-line no-constant-condition
                while (true) {
                    const [utxos, total] = await this.network.searchUnspentBoxes(query, { offset, limit });
                    for (const out of utxos) {
                        const op = this.parser.parseTokenLock(out);
                        if (op)
                            ops.push(op);
                    }
                    if (offset < total)
                        offset += limit;
                    else
                        break;
                }
            }
        }
        return ops;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9ja3NIaXN0b3J5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL3NlY3VyaXR5L3NlcnZpY2VzL2xvY2tzSGlzdG9yeS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQXVCLG9CQUFvQixFQUFDLE1BQU0sb0JBQW9CLENBQUE7QUFDN0UsT0FBTyxFQUFDLHFCQUFxQixFQUFDLE1BQU0sK0JBQStCLENBQUE7QUFXbkUsTUFBTSxVQUFVLGNBQWMsQ0FBQyxPQUFvQixFQUFFLE1BQWtCO0lBQ3JFLE9BQU8sSUFBSSxtQkFBbUIsQ0FBQyxPQUFPLEVBQUUsTUFBTSxDQUFDLENBQUE7QUFDakQsQ0FBQztBQUVELE1BQU0sbUJBQW1CO0lBQ3ZCLFlBQTRCLE9BQW9CLEVBQWtCLE1BQWtCO1FBQXhELFlBQU8sR0FBUCxPQUFPLENBQWE7UUFBa0IsV0FBTSxHQUFOLE1BQU0sQ0FBWTtJQUFHLENBQUM7SUFDeEYsS0FBSyxDQUFDLGlCQUFpQixDQUFDLFNBQW9CO1FBQzFDLE1BQU0sR0FBRyxHQUFnQixFQUFFLENBQUE7UUFDM0IsS0FBSyxNQUFNLEVBQUUsSUFBSSxTQUFTLENBQUMsR0FBRyxDQUFDLG9CQUFvQixDQUFDLEVBQUU7WUFDcEQsSUFBSSxFQUFFLEVBQUU7Z0JBQ04sTUFBTSxLQUFLLEdBQUc7b0JBQ1osb0JBQW9CLEVBQUUscUJBQXFCO29CQUMzQyxTQUFTLEVBQUU7d0JBQ1QsRUFBRSxFQUFFLEVBQUU7cUJBQ1A7aUJBQ0YsQ0FBQTtnQkFDRCxNQUFNLEtBQUssR0FBRyxHQUFHLENBQUE7Z0JBQ2pCLElBQUksTUFBTSxHQUFHLENBQUMsQ0FBQTtnQkFDZCxpREFBaUQ7Z0JBQ2pELE9BQU8sSUFBSSxFQUFFO29CQUNYLE1BQU0sQ0FBQyxLQUFLLEVBQUUsS0FBSyxDQUFDLEdBQUcsTUFBTSxJQUFJLENBQUMsT0FBTyxDQUFDLGtCQUFrQixDQUFDLEtBQUssRUFBRSxFQUFDLE1BQU0sRUFBRSxLQUFLLEVBQUMsQ0FBQyxDQUFBO29CQUNwRixLQUFLLE1BQU0sR0FBRyxJQUFJLEtBQUssRUFBRTt3QkFDdkIsTUFBTSxFQUFFLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQyxjQUFjLENBQUMsR0FBRyxDQUFDLENBQUE7d0JBQzFDLElBQUksRUFBRTs0QkFBRSxHQUFHLENBQUMsSUFBSSxDQUFDLEVBQUUsQ0FBQyxDQUFBO3FCQUNyQjtvQkFDRCxJQUFJLE1BQU0sR0FBRyxLQUFLO3dCQUFFLE1BQU0sSUFBSSxLQUFLLENBQUE7O3dCQUM5QixNQUFLO2lCQUNYO2FBQ0Y7U0FDRjtRQUNELE9BQU8sR0FBRyxDQUFBO0lBQ1osQ0FBQztDQUNGIn0=